import { useAppSelector } from 'reduxTyped'
import { ChannelStatus } from 'common/core/interfaces/channelStatuses'
import { getInstagramChannelStatus } from 'common/core/selectors/channelSelectors'

export const useIsIgDisconnected = () => {
  const igStatus = useAppSelector(getInstagramChannelStatus)
  return igStatus !== ChannelStatus.ACTIVE
}
